import makeList from './makeList.js'

let viewFloor = '自然エネルギー棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '自エネ1階廊下',
        file: './data/I41a_1.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 775.0556792873051, 476.61469933184856 ],
        },
      },
      { description: '自エネ階段室',
        file: './data/I41b.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 743.8752783964366, 331.84855233853006 ],
        },
      },
      { description: '自エネ機械室',
        file: './data/I41c.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 579.0645879732739, 514.4766146993319 ],
        },
      },
      { description: '自エネ機械部品保管庫',
        file: './data/I41d.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 551.2820512820514, 412.9999999999999 ],
        },
      },
      { description: '自エネ機械部品保管庫(2)',
        file: './data/I41e_2.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 641.4253897550111, 269.4877505567929 ],
        },
      },
      { description: '自エネ車両整備室',
        file: './data/I41g.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 652.5612472160357, 510.022271714922 ],
        },
      },
      { description: '自エネ制御室',
        file: './data/I41h.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 828.5077951002227, 434.29844097995544 ],
        },
      },
      { description: '自エネ蓄電池室',
        file: './data/I41i.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 902.0044543429844, 405.3452115812918 ],
        },
      },
      { description: '自エネ部品庫',
        file: './data/I41j.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 706.0133630289532, 463.25167037861917 ],
        },
      },
      { description: '自エネ木工室',
        file: './data/I41k.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 824.0534521158129, 383.0734966592428 ],
        },
      },
      { description: '自エネ野外装備保管庫',
        file: './data/I41l.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 853.0066815144766, 322.93986636971044 ],
        },
      },
      { description: '自エネ旅行準備室',
        file: './data/I41m.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 767.5606641123883, 342.27330779054915 ],
          syowaZoom: [ 732.739420935412, 249.44320712694878 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
